@if (!producao) {
  <div class="selector-color-options mb-3" role="group" aria-label="Cor do tema do sistema">
    @for (cor of cores; track cor.valor) {
      <button type="button" [id]="cor.valor" [class]="'selector-color-' + cor.valor"
        [attr.aria-label]="'Aplicar o tema na cor ' + cor.rotulo" [attr.aria-pressed]="corSelecionada() === cor.valor"
        (click)="selecionarCor(cor.valor)"
        [matTooltip]="'Visualizar o sistema na cor ' + cor.rotulo + '. Para ativar a cor no seu portal, entre em contato.'">
      </button>
    }
  </div>
}
